module.exports = __webpack_public_path__ + "static/img/5623_phase_function_Paper_Points.20933aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5623_phase_function_Paper_Points.png
// module id = fXsj
// module chunks = 0